import React from "react"
import win from "./Window.module.css"          
import styles from "./WindowAlert.module.css" 

type Props = {
  title: string
  onClose: () => void
  children: React.ReactNode
  width?: number
  height?: number
  bodyClassName?: string
  bodyStyle?: React.CSSProperties
  containerClassName?: string
}

export default function WindowAlert({
  title,
  onClose,
  children,
  width = 520,
  height = 360,
  bodyClassName,
  bodyStyle,
  containerClassName,
}: Props) {
  return (
    <div className={styles.overlay}>
      <div
        className={`${win.window} ${styles.alert} ${containerClassName || ""}`}
        style={{ width, height }}
        role="dialog"
        aria-modal="true"
      >
        <div className={win.header}>
          <div className={win.buttons}>
            <span className={win.red} onClick={onClose}>
              <svg className={win.icon} width="10" height="10" viewBox="0 0 10 10" aria-hidden>
                <path d="M1 1 L9 9 M9 1 L1 9" stroke="#6C130D" strokeWidth="2" />
              </svg>
            </span>
          </div>
          <span className={win.title}>{title}</span>
        </div>

        {/* corpo */}
        <div className={`${win.body} ${styles.body} ${bodyClassName || ""}`} style={bodyStyle}>
          {children}
        </div>
      </div>
    </div>
  )
}
